import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../components/WebView/icons/Close.svg'


const _withScopeId = n => (_pushScopeId("data-v-7ee0c93a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breakdown" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Close"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "break" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WebViewHeader = _resolveComponent("WebViewHeader")!
  const _component_TsNpsOverallV2 = _resolveComponent("TsNpsOverallV2")!
  const _component_TsNpsScorecardV2 = _resolveComponent("TsNpsScorecardV2")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_DashboardResponses = _resolveComponent("DashboardResponses")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WebViewHeader, null, {
      "left-button": _withCtx(() => [
        _createElementVNode("div", {
          class: "close",
          "data-test-tag": "close-modal",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
        }, _hoisted_3)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_BaseCard, { class: "nps-summary" }, {
        default: _withCtx(() => [
          _createVNode(_component_TsNpsOverallV2, { "is-mobile": "" }),
          _hoisted_5,
          _createVNode(_component_TsNpsScorecardV2)
        ], undefined, true),
        _: 1
      }),
      (_ctx.teamScoreboard)
        ? (_openBlock(), _createBlock(_component_DashboardResponses, {
            key: 0,
            "is-side-bar": false,
            "show-badges": true,
            "external-filters": _ctx.dashboardResponsesFilters,
            "mobile-question-type": _ctx.mobileQuestionType,
            class: "responses",
            "apply-scorecard-template-filter": ""
          }, null, 8, ["external-filters", "mobile-question-type"]))
        : _createCommentVNode("", true)
    ])
  ]))
}